var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup30486(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30486",
    "data-name": "Group 30486",
    transform: "translate(-776 -59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(778 59)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8707",
    "data-name": "Rectangle 8707",
    transform: "translate(776 64)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0h0A6.5,6.5,0,0,1,13,6.5v4.25A3.25,3.25,0,0,1,9.75,14H3.25A3.25,3.25,0,0,1,0,10.75V6.5A6.5,6.5,0,0,1,6.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5.5h0a6,6,0,0,1,6,6v4.158A2.842,2.842,0,0,1,9.658,13.5H3.342A2.842,2.842,0,0,1,.5,10.658V6.5a6,6,0,0,1,6-6Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(787 59)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8708",
    "data-name": "Rectangle 8708",
    transform: "translate(785 64)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0h0A6.5,6.5,0,0,1,13,6.5v4.25A3.25,3.25,0,0,1,9.75,14H3.25A3.25,3.25,0,0,1,0,10.75V6.5A6.5,6.5,0,0,1,6.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5.5h0a6,6,0,0,1,6,6v4.158A2.842,2.842,0,0,1,9.658,13.5H3.342A2.842,2.842,0,0,1,.5,10.658V6.5a6,6,0,0,1,6-6Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    transform: "translate(796 59)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8709",
    "data-name": "Rectangle 8709",
    transform: "translate(794 64)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0h0A6.5,6.5,0,0,1,13,6.5v4.25A3.25,3.25,0,0,1,9.75,14H3.25A3.25,3.25,0,0,1,0,10.75V6.5A6.5,6.5,0,0,1,6.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5.5h0a6,6,0,0,1,6,6v4.158A2.842,2.842,0,0,1,9.658,13.5H3.342A2.842,2.842,0,0,1,.5,10.658V6.5a6,6,0,0,1,6-6Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup30486);
export default __webpack_public_path__ + "static/media/group-30486.9e43b71acbf36796c023c934213cd9f0.svg";
export { ForwardRef as ReactComponent };